import type * as lazyIndex from './lazyIndex';
import type { CopilotIconProps } from './components/CopilotIcon24Color';
import { createLazyComponent, type LazyComponent, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CopilotIcon16Regular" */ './lazyIndex'),
    { name: 'CopilotIcon16Regular' }
);

type LazySVG = LazyComponent<React.SVGProps<SVGSVGElement>, SVGSVGElement, void>;

export const CopilotIcon16Regular: LazySVG = createLazyComponent(
    lazyModule,
    m => m.CopilotIcon16Regular
);

export const CopilotIcon20Regular: LazySVG = createLazyComponent(
    lazyModule,
    m => m.CopilotIcon20Regular
);

export const CopilotIcon24Color: LazyComponent<CopilotIconProps, SVGSVGElement, void> =
    createLazyComponent(lazyModule, m => m.CopilotIcon24Color);

export const CopilotIconSuiteHeader: LazySVG = createLazyComponent(
    lazyModule,
    m => m.CopilotIconSuiteHeader
);

export const CopilotIconColorSuiteHeader: LazySVG = createLazyComponent(
    lazyModule,
    m => m.CopilotIconColorSuiteHeader
);
